<template>
	<div class="main" style="padding-bottom: 100px;">
		<hwk-header></hwk-header>
		<div class="warp car-main flex">
			<div class="c-l">
				<div class="title flex pointer" @click="goBack"><i class="el-icon-arrow-left"></i><span
						style="margin-left: 5px;">确认订单</span>
				</div>
				<div class="title">确认收货地址
					<span @click="dialogFormVisible = true" v-if="form.address_name">编辑地址</span>
				</div>

				<div class="addr2 flex" v-if="form.address_name">
					<i class="el-icon-location"></i>
					<div class="r">
						<p><span>{{form.address_address_one}}</span><span>
								{{form.address_city}}</span><span>{{form.address_province}}
							</span><span>{{form.address_country}}</span>
						</p>
						<p><span>{{form.address_name}}</span><span>{{form.address_phone}}</span><span>{{form.address_email}}</span>
						</p>
						<p><span>出售平台：{{form.address_source_string}}</span><span>店铺：{{form.address_user_shop_string}}</span><span>订单编号：{{form.address_other_order_number}}</span>
						</p>
					</div>
				</div>
				<div class="addr1 flex" v-else @click="dialogFormVisible = true">
					<i class="el-icon-circle-plus"></i><span>添加新地址</span>
				</div>
				<div class="title">确认订单信息
				</div>
				<div class="list">
					<div class="item2 flex">
						<div class="i i1">商品</div>
						<div class="i i2">价格</div>
						<div class="i i3">数量</div>
						<div class="i i4">小计</div>
					</div>
					<div class="item flex" v-for="(item,index) in list" :key="index">
						<div class="m flex">
							<img :src="http + item.goods.image" />
							<div class="con flex">
								<div class="cl">
									<div class="t">{{item.goods.title}}</div>
									<div class="p">{{item.goods_child.sku_string}}</div>
									<div class="p">{{item.warehouse.name}}</div>
								</div>
								<div class="cm">￥<b class="num-din">{{item.goods_child.price}}</b></div>
								<div class="cr">
									<el-input-number style="width: 140px;" v-model="item.pay_number" :min="1"
										:max="99999" :disabled='false' label="描述文字"></el-input-number>
								</div>
							</div>
						</div>
						<div class="r">￥<span><b class="num-din">{{getMoney(item)}}</b></span></div>
					</div>
				</div>
			</div>
			<div class="c-r">
				<div class="title">付款详情</div>
				<div class="datas">
					<div class="item flex">
						<div class="l">商品数量</div>
						<div class="r1">共<b class="num-din">{{getNumber(list)}}</b>件</div>
					</div>
					<div class="item flex">
						<div class="l">商品总价</div>
						<div class="r2">￥<span><b class="num-din">{{getTotal(list)}}</b></span></div>
					</div>
					<div class="item flex">
						<div class="l">签名服务<span>(欧盟国家暂不支持签名服务，请勿勾选)</span></div>
						<div class="r3 flex">
							<div class="i" @click="changeSign(1)">
								<img src="@/assets/f2.png" v-if="sign_service == 1">
								<img src="@/assets/f1.png" v-else>
								<span>是</span>
							</div>
							<div class="i" @click="changeSign(0)">
								<img src="@/assets/f2.png" v-if="sign_service == 0">
								<img src="@/assets/f1.png" v-else>
								<span>否</span>
							</div>
						</div>
					</div>
					<div class="item flex">
						<div class="l">是否为老客户订单</div>
						<div class="r3 flex">
							<div class="i" @click="changeNew(2)">
								<img src="@/assets/f2.png" v-if="is_new == 2">
								<img src="@/assets/f1.png" v-else>
								<span>是</span>
							</div>
							<div class="i" @click="changeNew(1)">
								<img src="@/assets/f2.png" v-if="is_new == 1">
								<img src="@/assets/f1.png" v-else>
								<span>否</span>
							</div>
						</div>
					</div>
					<div class="item flex" v-if="is_new == 2">
						<div class="l">客户收货时间</div>
						<div class="r3 flex shtime">
							<el-date-picker style="width: 130px;text-align: right;border: 0;" align="right"
								v-model="order_receive_time" type="date" format="yyyy-MM-dd" value-format="timestamp"
								placeholder="选择时间">
							</el-date-picker>
							<!-- <el-dropdown>
								<span class="el-dropdown-link">
									选择时间<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item>黄金糕</el-dropdown-item>
									<el-dropdown-item>狮子头</el-dropdown-item>
									<el-dropdown-item>螺蛳粉</el-dropdown-item>
									<el-dropdown-item>双皮奶</el-dropdown-item>
									<el-dropdown-item>蚵仔煎</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown> -->
						</div>
					</div>
				</div>
				<div class="btns flex">
					<div class="btns-l">
						<div class="t">实付款</div>
						<div class="p">￥<span><b class="num-din">{{getPayMoney(list,sign_service,is_new)}}</b></span>
						</div>
					</div>
					<div class="btns-r flex">
						<div class="btn btn1 pointer" @click="goBack">返回</div>
						<div class="btn btn2 pointer" @click="pay">{{is_new == 2?'去提交':'去结算'}}</div>
					</div>

				</div>
			</div>
		</div>
		<el-dialog title="填写收货地址" :visible.sync="dialogFormVisible" width="980px">
			<div class="textarea">
				<el-input type="textarea" :rows="3" placeholder="在这里粘贴或输入地址..." v-model="textarea">
				</el-input>
				<el-button type="primary" size="small" @click="analysis">识别地址</el-button>
			</div>
			<div class="tips flex">
				<i class="el-icon-warning-outline"></i>
				<span>自动输入是机器学习的结果，无法保证完全正确，请检查下方地址。</span>
			</div>

			<el-form :model="form" label-position="left" :rules="rules" ref="ruleForm">
				<table class="table-form">
					<tr>
						<td>
							<el-form-item label="姓名" :label-width="formLabelWidth" prop="address_name">
								<el-input v-model="form.address_name" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
						<td>
							<el-form-item label="电话" :label-width="formLabelWidth" prop="address_phone">
								<el-input v-model="form.address_phone" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址一" :label-width="formLabelWidth" prop="address_address_one">
								<el-input v-model="form.address_address_one" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址二" :label-width="formLabelWidth">
								<el-input v-model="form.address_address_two" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址三" :label-width="formLabelWidth">
								<el-input v-model="form.address_address_three" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td>
							<!-- <el-form-item label="门牌号" :label-width="formLabelWidth">
								<el-input v-model="form.address_house_number" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item> -->
							<el-form-item label="邮编" :label-width="formLabelWidth" prop="address_zip_code">
								<el-input v-model="form.address_zip_code" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td>
						<td>
							<el-form-item label="邮箱" :label-width="formLabelWidth">
								<el-input v-model="form.address_email" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td>
							<el-form-item label="省/州/府" :label-width="formLabelWidth" prop="address_province">
								<el-input v-model="form.address_province" autocomplete="off"
									placeholder="请输入"></el-input>
								<!-- <el-select v-model="form.address_province" placeholder="请选择" style="width: 100%;"
									@change="changeProvinces" :disabled="!form.address_country">
									<el-option :label="item.label" :value="item.value" v-for="(item,index) in provinces"
										:key="index"></el-option>
								</el-select> -->
							</el-form-item>
						</td>
						<td>
							<el-form-item label="城市/区" :label-width="formLabelWidth" prop="address_city"
								:disabled="!form.address_province">
								<el-input v-model="form.address_city" autocomplete="off" placeholder="请输入"></el-input>
								<!-- <el-select v-model="form.address_city" placeholder="请选择" style="width: 100%;">
									<el-option label="区域一" value="shanghai"></el-option>
									<el-option label="区域二" value="beijing"></el-option>
								</el-select> -->
							</el-form-item>
						</td>
					</tr>
					<tr>
						<!-- <td>
							<el-form-item label="邮编" :label-width="formLabelWidth" prop="address_zip_code">
								<el-input v-model="form.address_zip_code" autocomplete="off"
									placeholder="请输入"></el-input>
							</el-form-item>
						</td> -->
						<td colspan="2">
							<el-form-item label="国家" :label-width="formLabelWidth" prop="address_country">
								<el-input v-model="form.address_country" autocomplete="off"
									placeholder="请输入"></el-input>
								<!-- <el-select v-model="form.address_country" placeholder="请选择" style="width: 100%;"
									@change="changeCountry">
									<el-option :label="item.label" :value="item.value" v-for="(item,index) in countrys"
										:key="index"></el-option>
								</el-select> -->
							</el-form-item>
						</td>
					</tr>
				</table>

				<el-row :gutter="20">
					<el-col :span="8">
						<el-form-item label="" label-width="0" prop="address_source_id">
							<el-select v-model="form.address_source_id" placeholder="选择订单来源" style="width: 100%;"
								@change="sourceChange">
								<el-option :label="item.name" :value="item.id" v-for="(item,index) in slist"
									:key="index"></el-option>

							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="" label-width="0" prop="address_user_shop_id">
							<div class="con" style="display: flex;align-items: center;justify-content: space-between;">
								<el-select v-model="form.address_user_shop_id" placeholder="选择店铺"
									style="flex: 1;width: 1px;" :disabled="!form.address_source_id"
									@change="shopChange">
									<el-option :label="item.name" :value="item.id" v-for="(item,index) in shoplist"
										:key="index"></el-option>
								</el-select>
								<i class="el-icon-circle-plus-outline" @click="addShop"
									style="font-size: 24px;margin-left: 10px;color: #FF6A00;"></i>
							</div>

						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="" label-width="0" prop="address_other_order_number">

							<el-input v-model="form.address_other_order_number" autocomplete="off"
								placeholder="请填写订单编号"></el-input>

						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitAddress('ruleForm')" size="small">保 存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="订单支付" :visible.sync="payShow" width="700px">
			<div class="payprice">
				支付金额:<span>￥{{order_money}}</span>
			</div>
			<div class="paytype flex">
				<div class="l">支付方式</div>
				<div class="r flex">
					<!-- <div class="i flex" @click="changePayType(0)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==0" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay1.jpg" class="img2" />
					</div> -->
					<div class="i flex" @click="changePayType(1)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==1" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay2.jpg" class="img2" />
					</div>
					<div class="i flex" @click="changePayType(2)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==2" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay3.jpg" class="img2" />
					</div>
					<div class="i flex" @click="changePayType(3)">
						<img src="@/assets/radio2.png" class="img1" v-if="payType==3" />
						<img src="@/assets/radio1.png" class="img1" v-else />
						<img src="@/assets/pay4.jpg" class="img2" />
					</div>
				</div>
			</div>
			<div class="payma1" v-if="payType==-1">
				<img src="@/assets/nopay.png" />
				<p>选择支付方式</p>
			</div>
			<div class="payma2" v-if="payType==0">
				<!-- <img :src="alpay" /> -->
				<iframe :src="alpay" width="210px" height="210px" frameborder="0" v-if="alpay">
				</iframe>
				<p>请使用<span>支付宝</span>扫码 <br>完成支付</p>
			</div>
			<div class="payma2" v-if="payType==1">
				<img :src="wxpay" />
				<p>请使用<span>微信</span>扫码 <br>完成支付</p>
			</div>
			<div class="payma3" v-if="payType==2">
				<!-- <div class="zh flex" v-for="(item,index) in order_bank_card" :key="index">
					<div class="l">账户信息</div>
					<div class="r flex">
						<div class="i">{{item.gs}}</div>
						<div class="i">{{item.yh}}</div>
						<div class="i">{{item.kh}}</div>
					</div>
				</div> -->
				<div class="zh flex" v-for="(item,index) in order_bank_card2" :key="index">
					<div class="l">账户信息</div>
					<div class="r flex">
						{{item}}
					</div>
				</div>
				<div class="pz">
					<div class="t">支付凭证<span>请打款至账户信息，并上传支付凭证</span></div>
					<el-upload class="avatar-uploader" :action="action" :headers="headers" :show-file-list="false"
						:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="imageUrl" :src="http + imageUrl" class="avatar">
						<div class="upload" v-else>
							<img src="@/assets/upimg.png" />
							<p>添加图片</p>
						</div>
					</el-upload>
				</div>
			</div>
			<div class="payma4" :class="{payma4on:canPay}" v-if="payType==3">
				<div class="t flex">
					<div class="l">可用额度</div>
					<div class="r">￥<span class="num-din">{{user_money}}</span></div>
				</div>
				<div class="ma">
					<img src="@/assets/sx1.png" v-if="canPay" />
					<img src="@/assets/sx2.png" v-else />
					<p>{{canPay?'点击确认支付':'额度不足，请选择其他支付方式'}}</p>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="payShow = false" size="small">关闭</el-button>
				<el-button type="primary" @click="paySubmit" size="small">确认支付</el-button>
			</div>
		</el-dialog>
		<navigation :cartshow="false"></navigation>
	</div>
</template>

<script>
	// import json from '../api/json.js'
	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation
		},
		data() {
			return {
				order_receive_time: "",
				imageUrl: '',
				headers: {
					token: localStorage.getItem('token')
				},
				action: this.$upload,
				http: this.$imgUrl,
				sign_service: 0, //是否签名 0=否，1=是
				is_new: 1, //是否新订单：1=否，2=是
				canPay: false,
				payType: -1,
				payShow: false,
				textarea: '',
				dialogFormVisible: false,
				list: [],
				pageSize: 0,
				page: 1,
				form: {
					address_name: '',
					address_phone: '',
					address_address_one: '',
					address_address_two: '',
					address_address_three: '',
					// address_house_number: '',
					address_email: '',
					address_country: '',
					address_province: '',
					address_city: '',
					address_area: '',
					address_zip_code: '',
					address_source_id: '',
					address_source_string: '',
					address_user_shop_id: '',
					address_user_shop_string: '',
					address_other_order_number: '',
				},
				formLabelWidth: '80px',
				imageUrl: '',
				number: 0,
				rules: {
					address_name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					address_phone: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}],
					address_address_one: [{
						required: true,
						message: '请输入地址1',
						trigger: 'blur'
					}],
					// address_address_two: [{
					// 	required: true,
					// 	message: '请输入地址2',
					// 	trigger: 'blur'
					// }],
					// address_address_three: [{
					// 	required: true,
					// 	message: '请输入地址3',
					// 	trigger: 'blur'
					// }],
					// address_house_number: [{
					// 	required: true,
					// 	message: '请输入门牌号',
					// 	trigger: 'blur'
					// }],
					// address_email: [{
					// 	required: true,
					// 	message: '请输入邮箱',
					// 	trigger: 'blur'
					// }],

					address_country: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					address_province: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					address_city: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					address_source_id: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					address_user_shop_id: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					address_zip_code: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					address_other_order_number: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],

				},
				countrys: [],
				provinces: [],
				citys: [],
				user_money: 0,
				order_bank_card: [],
				order_bank_card2: [],
				order_id: "1",
				order_money: '',
				slist: [],
				shoplist: [],
				alpay: "",
				wxpay: "",
				timer1: null,
				timer2: null,
				from: ""

			};
		},
		created() {
			if (this.$route.query.from) {
				this.from = this.$route.query.from
			}


			this.list = localStorage.getItem('myPayCart') ? JSON.parse(localStorage.getItem('myPayCart')) : [];
			this.number = this.list.reduce((acc, curr) => acc + curr.pay_number, 0);
			// let obj = json.COUNTRIES
			// this.countrys = Object.keys(obj).map(item => {
			// 	return {
			// 		value: item,
			// 		label: obj[item]
			// 	}
			// });

			if (localStorage.getItem('myPayForm')) {
				this.form = JSON.parse(localStorage.getItem('myPayForm'))
				if (this.from = 'myShop') {
					this.dialogFormVisible = true

				}
			}


			this.getPayType()
			this.getslist()

		},
		computed: {
			getNumber() {
				return (list) => {
					return list.reduce((acc, curr) => acc + curr.pay_number, 0)
				}
			},

			getName() {
				return (n, i) => {
					console.log(n, i)
					if (i == 1) {
						let obj = json.COUNTRIES
						return obj[n]
					} else {
						return this.form.address_country ? json[this.form.address_country][n] : ''
					}
				}
			},
			getMoney() {
				return (data) => {
					let p = parseFloat(data.goods_child.price) * parseInt(data.pay_number)
					return p.toFixed(2)
				}
			},
			getTotal() {
				return (data) => {
					let p = this.list.reduce((acc, curr) => acc + parseFloat(curr.goods_child.price) * parseInt(curr
						.pay_number), 0);
					return p.toFixed(2)
				}
			},
			getPayMoney() {
				return (list, s, n) => {
					if (n == 2) {
						return 0
					} else {
						let p1 = list.reduce((acc, curr) => acc + parseFloat(curr.goods_child.price) * parseInt(curr
							.pay_number), 0);
						let total = list.reduce((acc, curr) => acc + parseInt(curr
							.pay_number), 0);

						let p2 = total * 100
						return s == 1 ? (p1 + p2).toFixed(2) : p1.toFixed(2)

					}
				}
			},
		},

		beforeDestroy() {
			this.clear1()
			this.clear2()
		},
		methods: {
			clear1() {
				if (this.timer1) {
					clearInterval(this.timer1)
					this.timer1 = null
				}
			},
			clear2() {
				if (this.timer2) {
					clearInterval(this.timer2)
					this.timer2 = null
				}
			},
			analysis() {
				if (!this.textarea) {
					this.$message.error('请输入要识别的内容!');
					return
				}
				this.$http.post('/api/order/address_analysis', {
					address: this.textarea,

				}).then(res => {
					if (res.code == 1) {
						this.form.address_name = res.data.name
						this.form.address_phone = res.data.phone_arr.length > 0 ? res.data.phone_arr[0] : ''
						this.form.address_address_one = res.data.result.route + res.data.result.streetNum
						// this.form.address_house_number = res.data.result.streetNum
						this.form.address_email = res.data.email
						this.form.address_country = res.data.result.country
						this.form.address_province = res.data.result.province
						this.form.address_city = res.data.result.city
						this.form.address_zip_code = res.data.result.postcode

					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}


				});
			},
			submitAddress(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.dialogFormVisible = false
					} else {
						this.$message.error('您有信息未填写!');

					}
				});
			},
			addShop() {
				localStorage.setItem('myPayForm', JSON.stringify(this.form));
				// this.$router.push({
				// 	path: "/myShop",
				// 	query: {
				// 		addShow: 1
				// 	}
				// });
				const routeData = this.$router.resolve({
					path: '/myShop'
				});
				window.open(routeData.href, '_blank');
			},
			paySubmit() {
				if (this.payType < 2) {
					this.payShow = false
					setTimeout(() => {
						this.$router.push({
							path: "/orderList"
						});
					}, 2000)
				}
				// 银联支付
				if (this.payType == 2) {
					this.$http.post('/api/order/pay_pull', {
						order_id: this.order_id,
						type: 4,
						extend_yl_images: this.imageUrl
					}).then(res => {
						console.log(res)
						this.payShow = false
						this.$message({
							type: 'success',
							message: '操作成功!'
						});
						setTimeout(() => {
							this.$router.push({
								path: "/orderList"
							});
						}, 2000)
					});
				}
				// 授信支付
				if (this.payType == 3) {
					if (!this.canPay) {
						this.$message.error('额度不足，请选择其他支付方式');
						return
					}

					this.$http.post('/api/order/pay_pull', {
						order_id: this.order_id,
						type: 1
					}).then(res => {
						console.log(res)
						this.payShow = false
						this.$message({
							type: 'success',
							message: '操作成功!'
						});
						setTimeout(() => {
							this.$router.push({
								path: "/orderList"
							});
						}, 2000)
					});
				}
			},

			shopChange() {
				let index = this.shoplist.findIndex(item => item.id == this.form.address_user_shop_id)
				this.form.address_user_shop_string = this.shoplist[index].name
			},


			sourceChange() {
				let index = this.slist.findIndex(item => item.id == this.form.address_source_id)
				this.form.address_source_string = this.slist[index].name
				this.$http.get('/api/user_shop/index', {
					params: {
						page: 1,
						limit: 9999,
						source_id: this.form.address_source_id
					}
				}).then(res => {
					console.log(res)
					this.shoplist = res.data.data

				});

			},

			getslist() {
				this.$http.get('/api/user_shop/source_list', {

				}).then(res => {
					console.log(res)
					this.slist = res.data

				});
			},
			// 省
			changeProvinces(v) {
				console.log(v)
			},
			//国家
			changeCountry(v) {
				console.log(v)
				let obj = json[v]
				this.provinces = Object.keys(obj).map(item => {
					return {
						value: item,
						label: obj[item]
					}
				});
				console.log(this.provinces)
			},
			pay() {
				let json = this.list.map(item => {
					return {
						goods_child_id: item.goods_child_id,
						warehouse_id: item.warehouse_id,
						pay_number: item.pay_number
					}
				})

				if (this.is_new == 2 && !this.order_receive_time) {
					this.$message({
						type: 'error',
						message: '请选择收货时间!'
					});
					return
				}

				if (!this.form.address_source_id) {
					this.$message({
						type: 'error',
						message: '请选择平台!'
					});
					return
				}

				if (!this.form.address_user_shop_id) {
					this.$message({
						type: 'error',
						message: '请选择店铺!'
					});
					return
				}
				if (!this.form.address_other_order_number) {
					this.$message({
						type: 'error',
						message: '请输入订单号!'
					});
					return
				}

				// console.log(json, JSON.stringify(json))
				this.$http.post('api/order/add', {
					goods_ids_jsons: JSON.stringify(json),
					sign_service: this.sign_service,
					is_new: this.is_new,
					order_receive_time: this.order_receive_time,
					...this.form
				}).then(res => {
					if (res.code == 1) {
						// this.$message({
						// 	type: 'success',
						// 	message: '下单成功!'
						// });
						localStorage.removeItem('myPayCart')
						if (localStorage.getItem('myPayForm')) {
							localStorage.removeItem('myPayForm')
						}

						let ids = this.list.filter(item => item.id != 0).map(item => item.id).toString()
						if (ids) {
							this.delcarts(ids)
						}

						if (this.is_new == 1) {
							this.payShow = true
							this.order_id = res.data.order_data.id
							this.order_money = res.data.order_data.pay_price
							this.canPay = parseFloat(this.user_money) >= parseFloat(this.order_money)
						} else {
							setTimeout(() => {
								this.$router.push({
									path: "/orderList"
								});
							}, 2000)
						}
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				});
			},
			// 删除购物车
			delcarts(ids) {
				this.$http.post('/api/user_car/del', {
					id: ids
				}).then(res => {
					this.getcartlist()
				});
			},
			getcartlist() {
				this.$http.get('/api/user_car/index', {}).then(res => {
					let number = res.data.data.length
					localStorage.setItem('cartNumber', number);
					this.$store.dispatch('setCartNumber', number);
				});

			},
			goBack() {
				this.$router.go(-1);
			},
			changeSign(i) {
				this.sign_service = i
			},
			changeNew(i) {
				this.is_new = i
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = file.response.data.url;
			},
			beforeAvatarUpload(file) {
				const isJPG = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4'].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},
			changePayType(i) {
				this.payType = i
				if (i < 2) {
					let type = i == 0 ? 2 : 3
					this.$http.post('/api/order/pay_pull', {
						order_id: this.order_id,
						type: type
					}).then(res => {
						console.log(res)
						if (this.payType == 0) {
							this.alpay = res.data

							this.clear1()
							this.timer1 = setInterval(() => {
								this.getData(this.order_id)
							}, 3000)

						}
						if (this.payType == 1) {
							this.wxpay = res.data
							this.clear2()
							this.timer2 = setInterval(() => {
								this.getData(this.order_id)
							}, 3000)
						}
					});
				} else {
					this.clear1()
					this.clear2()
				}

			},
			getData(id) {
				this.$http.get('/api/order/info', {
					params: {
						id: id
					}
				}).then(res => {
					console.log(res)
					if (res.data.status == 20) {
						this.clear1()
						this.clear2()
						this.payShow = false
					}
				}).catch(() => {

				});

			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},
			getPayType() {

				this.$http.get('/api/order/pay_type', {

				}).then(res => {
					console.log(res)
					this.user_money = res.data.user_money
					let obj = res.data.order_bank_card

					let arr = Object.values(obj)
					this.order_bank_card2 = arr
					arr.forEach(item => {
						this.order_bank_card.push({
							gs: item.split(' ')[0],
							yh: item.split(' ')[1],
							kh: item.split(' ')[2],
						})
					})
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.shtime .el-input__inner {
		border: 0 !important;
	}

	.payma4 {
		.t {
			height: 40px;
			line-height: 40px;

			.l {

				font-weight: 500;
				font-size: 14px;
				color: #000000;
				text-align: left;
			}

			.r {
				margin-left: 10px;
				color: #A9A9A9;
				font-size: 14px;

				span {
					font-size: 22px;
					font-weight: 600;
				}
			}
		}

		.ma {
			margin-top: 40px;
			display: flex;
			flex-direction: column;
			text-align: center;
			align-items: center;
			justify-content: center;

			img {
				width: 104px;
				height: 88px;
			}

			p {
				font-size: 12px;
				color: #FF233F;
				height: 20px;
				line-height: 20px;
				margin-top: 15px;
			}
		}
	}

	.payma4on {


		.t {
			.r {
				color: @color1;


			}
		}

		.ma {

			p {
				color: #3F3F3F;
			}
		}
	}

	.avatar {
		width: 100px;
		height: 100px;
		display: block;
	}

	.payma3 {
		.upload {
			width: 100px;
			height: 100px;
			background: #FFFFFF;
			border-radius: 2px;
			border: 1px solid #EBEBEB;
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: center;
			text-align: center;
			margin-top: 10px;

			img {
				width: 30px;
				height: 30px;
			}

			p {
				line-height: 20px;
				height: 20px;
				font-size: 14px;
				color: #A9A9A9;
				text-align: center;
				margin-top: 10px;
			}
		}

		.zh {
			margin-top: 20px;

			.l {

				font-size: 14px;
				color: #000000;
				text-align: left;
			}

			.r {
				flex: 1;
				width: 1px;
				margin-left: 20px;
				height: 40px;
				line-height: 40px;
				border: 1px solid #EBEBEB;
				position: relative;
				font-size: 14px;
				color: #3F3F3F;
				padding: 0 10px;
				// &::after {
				// 	content: '';
				// 	position: absolute;
				// 	top: 5px;
				// 	bottom: 5px;
				// 	left: 33.33%;
				// 	width: 1px;
				// 	background-color: #EBEBEB;
				// }

				// &::before {
				// 	content: '';
				// 	position: absolute;
				// 	top: 5px;
				// 	bottom: 5px;
				// 	right: 33.33%;
				// 	width: 1px;
				// 	background-color: #EBEBEB;
				// }

				.i {
					font-size: 14px;
					color: #3F3F3F;
					flex: 1;
					align-items: center;
					text-align: center;
				}
			}
		}

		.pz {
			margin-top: 20px;

			.t {
				text-align: left;
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				color: @color1;
				text-align: left;

				span {
					color: @color2;
					margin-left: 10px;
					font-size: 12px;
				}
			}

			.upload {
				img {}

				p {}
			}

		}
	}

	.payma2 {
		padding: 60px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;

		img {
			width: 200px;
			height: 200px;
		}

		p {
			margin-top: 20px;
			font-weight: 500;
			font-size: 14px;
			color: #A9A9A9;
			text-align: center;
			line-height: 24px;

			span {
				color: @color2;
				padding: 0 10px;
			}
		}
	}

	.payma1 {
		padding: 60px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;

		img {
			width: 104px;
			height: 104px;
		}

		p {
			margin-top: 20px;
			height: 20px;
			font-weight: 500;
			font-size: 14px;
			color: #A9A9A9;
			text-align: center;
			line-height: 20px;
		}
	}

	.payprice {


		font-size: 14px;
		color: #000000;
		text-align: left;

		span {
			font-weight: bold;
			font-size: 22px;
			color: #FF6A00;
			text-align: left;
			margin-left: 10px;
		}
	}

	.paytype {
		padding: 20px 0;

		.l {


			font-size: 14px;
			color: #000000;
			text-align: left;
		}

		.r {
			flex: 1;
			width: 1px;
			margin-left: 10px;

			.i {
				margin-right: 20px;
				cursor: pointer;

				.img1 {
					width: 16px;
					height: 16px;

				}

				.img2 {
					margin-left: 10px;
					width: 100px;
					height: 30px;
				}
			}
		}
	}

	.table-form {

		border-collapse: collapse;
		/* 关键：合并边框 */
		width: 100%;
		border: 1px solid #ccc;
		/* 可选：外边框 */
		margin-bottom: 20px;

		td {
			border: 1px solid #ccc;
			/* 细线边框 */
			padding: 10px;
		}
	}

	.el-form-item {
		margin-bottom: 0 !important;
	}

	.textarea {
		position: relative;

		.el-button {
			position: absolute;
			bottom: 10px;
			right: 10px;
		}
	}

	.tips {
		height: 30px;
		background: #FFF5EE;
		align-items: center;
		justify-content: space-between;
		line-height: 30px;
		margin: 10px auto;
		padding: 0 10px;
		border-radius: 3px;

		i {
			color: @color2;
		}

		span {
			flex: 1;
			width: 1px;
			margin-left: 10px;
			font-size: 12px;
			color: #868E99;
			text-align: left;
		}
	}

	.car-main {
		align-items: flex-start;
		padding: 20px 0;
	}

	.c-l {
		flex: 1;
		width: 1px;
		background-color: #fff;
		padding: 20px;
		border-radius: 10px;
		margin-right: 20px;

		.addr2 {
			width: 100%;
			border-radius: 6px;
			border: 1px solid @color2;
			color: #868E99;
			margin: 30px auto;
			padding: 10px;
			box-sizing: border-box;
			align-items: flex-start;

			i {
				color: @color2;
				font-size: 24px;
				margin-right: 10px;
			}

			.r {
				flex: 1;
				width: 1px;

				p {
					font-size: 14px;
					color: @color1;
					line-height: 24px;
					text-align: left;

					span {
						margin-right: 30px;
					}
				}
			}

		}

		.addr1 {
			width: 100%;
			height: 90px;
			background: #FFFFFF;
			border-radius: 6px;
			border: 1px solid #D8D8D8;
			text-align: center;
			align-items: center;
			justify-content: center;
			color: #868E99;
			margin: 30px auto;

			span {
				font-size: 14px;
				margin-left: 10px;
			}
		}

		.list {
			.item2 {
				display: flex;
				align-items: center;
				justify-content: space-between;
				background-color: #F3F6F8;
				font-size: 12px;
				color: #11192D;
				height: 40px;
				line-height: 40px;

				.i {
					text-align: left;
				}

				.i1 {
					flex: 1;
					width: 1px;
					padding-left: 30px;
				}

				.i2 {
					width: 110px;
				}

				.i3 {
					width: 140px;
				}

				.i4 {
					width: 110px;

				}
			}

			.item {
				padding: 10px 0;

				.l {}

				.m {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					margin-right: 10px;

					img {
						width: 72px;
						height: 72px;
						background: #FFFFFF;
						border-radius: 6px;
						border: 1px solid #D8D8D8;
					}

					.con {
						flex: 1;
						width: 1px;
						margin-left: 10px;
						justify-content: space-between;

						.cl {
							flex: 1;
							width: 1px;

							.t {

								font-weight: 500;
								font-size: 14px;
								color: #11192D;
								line-height: 16px;
								text-align: left;
							}

							.p {

								height: 17px;
								line-height: 17px;
								font-size: 12px;
								color: #50607A;
								text-align: left;
							}
						}

						.cm {

							font-weight: 500;
							font-size: 14px;
							color: #11192D;
							text-align: center;
							width: 110px;
							text-align: left;
						}

						.cr {
							width: 140px;
						}
					}
				}

				.r {
					font-size: 14px;
					color: @color2;
					width: 110px;
					text-align: left;

					span {
						font-size: 20px;
						font-weight: 600;

					}
				}
			}
		}



		.title {
			text-align: left;
			font-size: 16px;
			color: @color1;
			height: 30px;
			line-height: 30px;
			margin-bottom: 20px;
			font-weight: 600;

			span {
				float: right;
				font-size: 14px;
				color: @color1;

			}

			&:hover {
				i {
					color: @color2;
				}

				span {
					color: @color2;
				}
			}
		}
	}

	.c-r {
		width: 370px;
		background: linear-gradient(180deg, #FFF5EE 0%, #FFFFFF 50%);
		border-radius: 10px;
		border: 1px solid #EBEBEB;
		box-sizing: border-box;
		padding: 10px;

		.datas {
			.item {
				height: 40px;
				line-height: 40px;

				.l {

					font-weight: bold;
					font-size: 14px;
					color: #11192D;
					text-align: left;

					span {
						font-size: 10px;
						color: #666;


					}
				}

				.r1 {
					flex: 1;
					width: 1px;
					text-align: right;
					font-weight: 500;
					font-size: 14px;
					color: #11192D;
				}

				.r2 {
					flex: 1;
					width: 1px;
					text-align: right;

					font-weight: 500;
					font-size: 14px;
					color: #11192D;

					span {
						font-size: 20px;
						font-weight: 600;

					}
				}

				.r3 {
					flex: 1;
					width: 1px;
					text-align: right;
					font-weight: 500;
					font-size: 14px;
					color: #11192D;
					display: flex;
					justify-content: end;

					.i {
						display: flex;
						align-items: center;

						img {
							width: 16px;
							height: 16px;
						}

						span {
							margin-left: 5px;
						}
					}
				}
			}
		}

		.btns {
			margin-top: 30px;
			position: relative;
			padding-top: 20px;

			&::after {
				content: '';
				height: 1px;
				background-color: #eee;
				position: absolute;
				top: 0;
				left: -10px;
				right: -10px;
			}

			.btns-l {
				flex: 1;
				width: 1px;

				.t {
					height: 20px;
					line-height: 20px;
					font-weight: bold;
					font-size: 14px;
					color: #11192D;
					text-align: left;

				}

				.p {
					height: 30px;
					line-height: 30px;
					font-size: 14px;
					color: #FF6A00;
					text-align: left;
					font-style: normal;
					text-transform: none;

					span {
						font-size: 22px;
						font-weight: 600;
					}
				}
			}

			.btns-r {
				text-align: center;
			}

			.btn {
				font-size: 16px;
			}

			.btn1 {
				width: 62px;
				height: 48px;
				line-height: 48px;
				background: #FFFFFF;
				border-radius: 10px;
				border: 1px solid #D8D8D8;
			}

			.btn2 {
				margin-left: 20px;
				width: 100px;
				height: 48px;
				line-height: 48px;
				background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
				border-radius: 10px;

				color: #fff;
			}
		}

		.title {
			color: @color1;
			font-size: 18px;
			font-weight: 600;
			height: 30px;
			line-height: 30px;
			text-align: left;
		}

		.empty {
			width: 100px;
			height: 100px;
			margin: 60px auto;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>